import axios from "axios";
import VueCookies from "vue-cookies";

export async function callApi(
  method,
  url,
  parameter = null,
  header = null,
  body = null
) {
  return await axios({
    method,
    headers: header == null ? {} : { ...header, sellerId: VueCookies.isKey("adminSellerId") ? VueCookies.get("adminSellerId") : 0, },
    data: body == null ? {} : body,
    url,
    params: parameter == null ? {} : parameter,
  })
    .then(function (response) {
      let data = response.data;
      return data;
    })
    .catch(async (error) => {
      console.log(error);
      if (error.response.status === 401) {
        VueCookies.remove("seller-token");
        alert("Login Timeout");
        window.location.href = "/login";
      }
    });
}
